var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RemoveSpacesRepository } from './remove-space-service.interface';
import { SpacesModel } from '../model/spaces-model';
let RemoveSpaceServiceImpl = class RemoveSpaceServiceImpl {
    constructor(_spacesModel, _removeSpacesRepository) {
        this._spacesModel = _spacesModel;
        this._removeSpacesRepository = _removeSpacesRepository;
    }
    async removeSpaces(selectedSpaces) {
        const data = await this._removeSpacesRepository.removeSpaces(selectedSpaces);
        if (data.length > 0) {
            this._spacesModel.update(spaces => this._removeSpaces(spaces, data));
        }
        return data;
    }
    _removeSpaces(spaces, data) {
        const removeIds = data.map(space => space.spaceId);
        return spaces.filter(space => {
            return !removeIds.includes(space.spaceId);
        });
    }
};
RemoveSpaceServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesModel)),
    __param(1, inject(RemoveSpacesRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _a : Object, typeof (_b = typeof RemoveSpacesRepository !== "undefined" && RemoveSpacesRepository) === "function" ? _b : Object])
], RemoveSpaceServiceImpl);
export { RemoveSpaceServiceImpl };
